var link_preview_default = {
  "fontElementMap": "dI1jw",
  "linkPreviewContainer": "qyEPJ",
  "linkPreview": "ILz84",
  "linkPreviewImage": "L8WHy",
  "linkPreviewPlaceholder": "fdJbc",
  "linkPreviewInfo": "pZV6C",
  "linkPreviewTitle": "yBobr",
  "linkPreviewDescription": "s6KTO",
  "linkPreviewUrl": "qhLIe",
  "linkPreviewResponsiveImage": "I7V2H",
  "loadingContainer": "_6z2xf",
  "errorIcon": "_2hmxl",
  "errorInfo": "PBWe0",
  "errorContainer": "kbwiN",
  "overlay": "kek-t",
  "thumbnailEnd": "_2EAPh",
  "thumbnailStart": "_5oL3N",
  "thumbnailTop": "jb-4z"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
